import React from "react";
import ServicesCard from "../../components/home/ServicesCard";
import FaqSection from "../../components/about/FAQ";

const imageStyle = {
  height: '250px',
  width: '100%',
  objectFit: 'cover',
  borderRadius: '8px',
};

const EquipmentTemplate = ({ content, equipmentList, language }) => {
  const t = content;

  return (
    <div>
      {/* Introduction Section */}
      <section
        style={{
          background: 'radial-gradient(circle, #ffffff 0%, #f8d4d4 100%)',
          padding: '20px',
        }}
      >
        <h1 className="text-center mb-4 mt-5">{t.heading}</h1>
        <p className="text-center mb-5 mx-auto" style={{ fontSize: '1.1rem', maxWidth: '70%' }}>
          {t.introText}
        </p>
      </section>

      {/* Equipment Models Section */}
      <section className="container py-5">
        <h2 className="text-center mb-4">{t.categoriesTitle}</h2>
        <div className="row text-center">
          {equipmentList.map((item, idx) => (
            <div className="col-md-4 mb-4" key={idx}>
              <img src={item.image} alt={item.name} style={imageStyle} />
              <h5 className="mt-3">{item.name}</h5>
              <p><strong>{language === 'sa' ? 'المواصفات:' : 'Specs:'}</strong> {item.specs}</p>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Featured Equipment Section */}
      <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container">
          <h2 className="text-center mb-4">{t.featuredTitle}</h2>
          <p className="text-center mb-4">{t.featuredDescription}</p>

          <ul className="list-group">
            {equipmentList.map((item, idx) => (
              <li key={idx} className="list-group-item mb-3">
                <div className="row">
                  <div className="col-md-3">
                    <img src={item.image} alt={item.name} style={imageStyle} />
                  </div>
                  <div className="col-md-9">
                    <h5>{item.name}</h5>
                    <p>{item.description}</p>
                    <p><strong>{language === 'sa' ? 'المواصفات:' : 'Specs:'}</strong> {item.specs}</p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <ServicesCard showHeading={false} showParagraph={false} />
      <FaqSection />
    </div>
  );
};

export default EquipmentTemplate;
